<template>
  <Card noBorder>
    <SectionHeader
      title="UID/GID Management"
    >
      {{ $options.instructions }}
    </SectionHeader>
    <Checkbox
      v-model="enableManagedUID"
      :label="$options.label"
    />
  </Card>
</template>
<script>
import { Card, Checkbox } from '@jumpcloud/ui-components';
import SectionHeader from 'client/settings/components/SectionHeader.vue';
import createComputedObjectBinding from 'client/util/createComputedObjectBinding';

export default {
  name: 'SectionUidGidManagement',

  components: {
    Card,
    Checkbox,
    SectionHeader,
  },

  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    enableManagedUID: {
      ...createComputedObjectBinding('enableManagedUID'),
    },
  },
  label: 'Enable UID/GID management for users',
  instructions: 'A User ID (UID) is a unique value assigned by a Unix operating device to each user.',
};
</script>

<style module>
.instructions {
  font-size: var(--jcBodySmall);
}

.instructionItem {
  margin-bottom: var(--jc-spacer-small);
}
</style>
